import React from 'react';
import { useState, useEffect, Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import CustomizedTables, { Action } from '../../atoms/table';
import { StyledTableCell, StyledTableRow } from '../../atoms/table/tableStyles';
import Dialog from "../../atoms/dialog";
import { useForm } from 'react-hook-form';
import ProfileConfig from '../../../store/profile/actions';
import { getProfileConfiguration } from '../../../store/profile/selectors';
import CircularProgress from '@material-ui/core/CircularProgress';
import CustomizedDialogs from '../../atoms/dialog';
import { makeStyles } from '@material-ui/core/styles';
import { veifyDeployConfiguration } from "../../../store/blueprint/actions";
import { validateRslice, validateIpOrDNS, validateEmail } from '../../../config/validations';
// const short = require('short-uuid');

const useStyles = makeStyles((theme) => ({
  typography: {
    ...theme.typography.button,
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(5, 10, 5, 40),
  },

  textCapitalise: {
    textTransform: 'capitalize'
  }
}));

const fields = [
  { label: 'Configuration Name', name: 'configuration_name', placeholder: 'Config one', columnWidth: '4' },
  { label: 'Organization Name', name: 'organization', placeholder: 'HyperBlox', columnWidth: '4' },
  { label: 'Group Name', name: 'group', placeholder: 'admin', columnWidth: '4' },
  { label: 'Username', name: 'username', validation: validateEmail, columnWidth: '4' },
  { label: 'Password', name: 'password', type: 'password', columnWidth: '4' },
  { label: 'Resource Slice', name: 'rslice', placeholder: 'rslice', validation: validateRslice, columnWidth: '4' },
  { label: 'Service Slice', name: 'sslice', placeholder: 'S****', columnWidth: '4' },
  { label: 'Controller Hostname or IP', name: 'controller', placeholder: '192.168.***.**', validation: validateIpOrDNS, columnWidth: '4' },
  { label: 'HTTP Port', name: 'port', type: 'number', placeholder: '5*', columnWidth: '2' },
  { label: 'SSH Port', name: 'ssh_port', type: 'number', placeholder: '6000', columnWidth: '2' },
];


const Profile = () => {
  const [loading, setLoading] = useState(false);
  const [deleteLoader, setDeleteLoader] = useState(false);
  const [open, setOpen] = useState(false);
  const [deleteSchema, setDeleteSchema] = useState({});
  const [dialogBox, setDialogBox] = useState(false)
  const [action, setAction] = useState("")
  const [testLoading, setTestLoading] = useState(false);
  const classes = useStyles();
  const dispatch = useDispatch();
  useEffect(() => {
    setLoading(true)
    dispatch(ProfileConfig.getProfileConfigurationData()).then(() => setLoading(false));
  }, []);
  let configurationData = useSelector(getProfileConfiguration);
  // getting the config data from api

  const { register, handleSubmit, errors, reset, getValues } = useForm({
    //form for  taking config values
    defaultValues: {
      configuration_name: 'HyperBlox',
      organization: 'HyperBlox',
      group: 'admin',
      username: 'superadmin@hyperblox.io',
      password: '',
      rslice: '',
      sslice: '',
      controller: '',
      port: 82,
      ssh_port: 6000,
    },
  });

  const toggleLoading = () => setLoading((prev) => !prev);
  const toggleDeleteLoading = () => setDeleteLoader((prev) => !prev);
  const toggleTestLoading = () => setTestLoading((prev) => !prev);

  const addDeployment = () => {
    ///adding a  deployment configuration
    setDialogBox(true)
    reset({
      configuration_name: 'HyperBlox',
      organization: 'HyperBlox',
      group: 'admin',
      username: 'superadmin@hyperblox.io',
      password: '',
      rslice: '',
      sslice: '',
      controller: '',
      port: 82,
      ssh_port: 6000,
    })
    setAction("add")
  }

  const deleteData = (data) => {
    setOpen(true);
    setDeleteSchema(data);
  };

  const handleDelete = () => {
    // delete button and deleting a data
    toggleDeleteLoading();
    dispatch(ProfileConfig.deleteProfileConfigurationData(deleteSchema._id)).finally(() => {
      toggleDeleteLoading();
      setOpen(false);
      setDeleteSchema({});
    }).then(() => {
      setLoading(true);
      dispatch(ProfileConfig.getProfileConfigurationData()).then(() => setLoading(false));
    })
  };

  const onSubmit = (data) => {
    
    setLoading(true);
    if (!Boolean(data._id)) {
      delete data._id;
      dispatch(ProfileConfig.saveProfileConfigurationData({...data, rslice: data.rslice?.trim(), sslice: data.sslice?.trim()})).then(res => {
        if (res.success) {
          setDialogBox(false)
        }
        toggleLoading()
      }).catch((err) => {
        toggleLoading()
      });

    } else {
      dispatch(ProfileConfig.editProfileConfigurationData(data)).then(res => {
        if (res.success) {
          setDialogBox(false)
        }
        toggleLoading()
      }).catch(toggleLoading);
    }
    // setDialogBox(false)
  };

  const handleClose = () => {
    setOpen(false);
  };

  const resetForm = () => {
    reset({
      configuration_name: '',
      organization: '',
      group: '',
      username: '',
      password: '',
      rslice: '',
      sslice: '',
      controller: '',
      port: '',
      ssh_port: '',
    })
  }

  const deployTest = ({ controller, port, username, password }) => {
    //verfiying   the data
    setTestLoading(true);
    setLoading(true);
    const payload = { controller, port, username, password };
    const response = dispatch(veifyDeployConfiguration(payload)).then(() => { toggleTestLoading(); toggleLoading(); }).catch(() => { toggleTestLoading(); toggleLoading(); });

  }


  const dialogHandleClose = () => setDialogBox((prev) => !prev);



  return (
    <Grid container direction="row" spacing={2}>
      <CustomizedDialogs
        open={open}
        title="Delete"
        handleClose={handleClose}
        actions={
          <React.Fragment>
            <Button autoFocus onClick={handleClose} variant="outlined" color="primary">
              Cancel
            </Button>
            <Button autoFocus variant="contained" color="secondary" onClick={handleDelete} disabled={deleteLoader} startIcon={deleteLoader ? <CircularProgress color="secondary" size={20} className={classes.textCapitalise} /> : <Fragment />}>
              {deleteLoader ? "Deleting.." : "Delete"}
            </Button>
          </React.Fragment>
        }>
        <Typography>Do you want to delete the deployment configuration?</Typography>
      </CustomizedDialogs>

      <Grid container direction="row" alignItems="center" justify="center" style={{ padding: 10, justifyContent: 'end' }}>
        <Button id="addNewConfig" onClick={() => addDeployment()} variant="contained" className={classes.textCapitalise} data-ui-tour-id='add_deployment_config_btn' > Add New Deployment Configuration </Button>
      </Grid>
      <Grid item xs={12} data-ui-tour-id='config_table_container'>
        <ConfigurationTable configurationData={configurationData} reset={reset} deleteData={deleteData} dialogBox={setDialogBox} action={setAction} dispatch={dispatch} loading={loading} toggleLoading={setLoading} />
      </Grid>
      <Grid item xs={12}>
        <form onSubmit={handleSubmit(onSubmit)} noValidate reset={reset}>
          <input style={{ display: 'none' }} name="sourcepath" ref={register} />
          <input style={{ display: 'none' }} name="bptag" ref={register} />
          <input style={{ display: 'none' }} name="_id" ref={register} />


          {dialogBox && <Dialog
            title={action === "add" ? "Add Deployment Configuration" : "Edit Deployment Configuration"}
            handleClose={dialogHandleClose}
            className={classes.textCapitalise}
            open={true}
            paperProps={{ id: "addDeploymentConfigModal" }}
            actions={
              <>
                <Button onClick={() => resetForm()} color="primary" variant="outlined" style={{ marginRight: 10 }} className={classes.textCapitalise}>
                  Clear
                </Button>
                <Button onClick={handleSubmit(deployTest)} disabled={testLoading} startIcon={testLoading ? <CircularProgress color="secondary" size={20} /> : <Fragment />} color="primary" variant="contained" style={{ marginRight: 10, }} className={classes.textCapitalise}>
                  Test Configuration
                </Button>
                <Button onClick={handleSubmit(onSubmit)} disabled={loading} startIcon={(loading && !testLoading) ? <CircularProgress color="secondary" size={20} /> : <Fragment />} type="submit" color="primary" variant="contained" className={classes.textCapitalise}>
                  Save
                </Button>
              </>
            }
          >
            <Grid container direction="row" spacing={2}>
              {fields.map((field) => {
                return (
                  <Grid item xs={field.columnWidth}>
                    <TextField
                      InputLabelProps={{
                        shrink: true,
                      }}
                      type={field.type || 'text'}
                      fullWidth
                      required
                      label={field.label}
                      // placeholder={field.placeholder}
                      variant="outlined"
                      name={field.name}
                      id={field.name}
                      inputRef={register({ required: true, validate: field?.validation })}
                      error={Boolean(errors[field.name])}
                      helperText={(getValues(field.name) == '' && errors[field.name]) ? 'Field is required' : errors[field.name] ? (field?.label + ' is invalid') : ''}
                    />
                  </Grid>
                );
              })}
            </Grid>
          </Dialog>}
        </form>
      </Grid>
    </Grid>
  );
};

export default Profile;

const header = [
  { label: 'Configuration', name: 'configuration_name' },
  { label: 'Organization', _id: 'organization' },
  { label: 'Username', _id: 'username' },
  { label: 'Group', _id: 'group' },
  // { label: 'Password', _id: 'password' },
  { label: 'Resource Slice', _id: 'rslice' },
  { label: 'Service Slice', _id: 'sslice' },
  { label: 'Controller IP', _id: 'controller' },
  { label: 'HTTP Port', _id: 'port' },
  { label: 'SSH Port', _id: 'ssh_port' },
  // { label: 'Created At', _id: 'date' },
];

const ConfigurationTable = ({ configurationData = [], reset, setEdit, deleteData, dialogBox, action, dispatch, loading, toggleLoading }) => {
  const generateConfigurationNameForClone = (data) => {





    const { __v, user_id, _id, date, configuration_name, ...cloneData } = data;


    const clonedData = {
      ...cloneData,
      configuration_name: `${configuration_name}_copy`
    };



    dispatch(ProfileConfig.saveProfileConfigurationData(clonedData)).then(() => {
      toggleLoading(false)
    }).catch(toggleLoading);


  }
  const onMenuClick = (data) => (key) => {


    switch (key) {
      case 'edit':
        dialogBox(true)
        action("edit")
        reset(data || {});
        break;
      case 'delete':
        deleteData(data);
        break;
      case 'clone':
        action("clone")
        generateConfigurationNameForClone(data)
        break;
      default:
        break;

    }
  };
  return (
    <CustomizedTables size="small" headers={header} actions id={"deploymentConfigTable"}>
      {
        loading ?
          <StyledTableRow>
            <StyledTableCell align={'center'} colSpan={11} component="td" style={{ padding: 15 }}>
              Loading... <CircularProgress size={15} style={{ color: '#000' }} />
            </StyledTableCell>
          </StyledTableRow>
          : configurationData.length < 1 ?
            <StyledTableRow>
              <StyledTableCell align={'center'} colSpan={11} component="td" style={{ padding: 15 }}>
                No deployment configurations available.
              </StyledTableCell>
            </StyledTableRow> : configurationData.map((item, index) => {

              return (
                <StyledTableRow>
                  <StyledTableCell align={'left'}>{item.configuration_name || ''}</StyledTableCell>
                  <StyledTableCell align={'left'}>{item.organization || ''}</StyledTableCell>
                  <StyledTableCell align={'left'}>{item.username || ''}</StyledTableCell>
                  <StyledTableCell align={'left'}>{item.group || ''}</StyledTableCell>
                  {/* <StyledTableCell align={'left'}>{Array(item.password || ''.length).fill('*')}</StyledTableCell> */}
                  <StyledTableCell align={'left'}>{item.rslice || ''}</StyledTableCell>
                  <StyledTableCell align={'left'}>{item.sslice || ''}</StyledTableCell>
                  <StyledTableCell align={'left'}>{item.controller || ''}</StyledTableCell>
                  <StyledTableCell align={'left'}>{item.port || ''}</StyledTableCell>
                  <StyledTableCell align={'left'}>{item.ssh_port || ''}</StyledTableCell>
                  {/* <StyledTableCell align={'center'}>{item.date || ''}</StyledTableCell> */}
                  <Action onMenuClick={onMenuClick(item)} index={index} />
                </StyledTableRow>
              );
            })
      }
    </CustomizedTables>
  )
};


